// extracted by mini-css-extract-plugin
module.exports = {"two-col__container":"two-col-m__two-col__container__3BQ6t","two-col__card":"two-col-m__two-col__card__3f3Q_","two-col__ad":"two-col-m__two-col__ad__1aWej"};